import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostVermerkCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostVermerkCommandService],
  exports: []
})
export class PostVermerkCommandServiceModule { }
